import type { TaskListItem } from "../../../types/api";

interface Props {
  kpiTask: TaskListItem;
  childTasks: TaskListItem[];
  onClick: () => void;
}

export default function GoalCard({ kpiTask, childTasks, onClick }: Props) {
  const total = childTasks.length;
  const done = childTasks.filter((c) => c.status === "done").length;
  const percentage = total > 0 ? Math.round((done / total) * 100) : 0;

  return (
    <div
      className="p-4 radius-lg surface-base-fill border surface-base-stroke cursor-pointer hover:shadow-sm"
      onClick={onClick}>
      <h4 className="text-body-bold-md content-base-primary mb-10 line-clamp-2">{kpiTask.title}</h4>

      <div className="flex items-center justify-between mb-1">
        <p className="text-body-regular-sm content-base-low">
          <span className="text-body-bold-sm content-base-primary">{done}</span> / {total}
        </p>
        <p className="text-label-sm content-base-low">{percentage}%</p>
      </div>

      <div className="w-full h-2 radius-full surface-component-fill overflow-hidden">
        <div className="h-full radius-full background-brand-fill" style={{ width: `${percentage}%` }} />
      </div>
    </div>
  );
}

